import { BranchManagementChangeLogUserDto, UserManagementChangeLogUserDto } from '@core/services/dto/userchangelog.dto';
import { formateUTCtoTZ } from '@shared/utils';

export class UserManagementChangeLogModel {
    modifiedBy: string;
    userModified?: string;
    field: string;
    oldValue: string | null;
    newValue: string | null;
    timestamp: string;

    constructor(dto: UserManagementChangeLogUserDto) {
        this.modifiedBy = typeof dto.modifiedBy === 'string'
            ? dto.modifiedBy
            : null;
        this.userModified = dto.userModified
            ? typeof dto.userModified === 'string'
                ? dto.userModified
                : null
            : undefined;
        this.field = dto.field;
        this.oldValue = dto.oldValue;
        this.newValue = dto.newValue;
        this.timestamp = dto.timestamp ? formateUTCtoTZ(dto.timestamp) : '';
    }
}

export class BranchManagementChangeLogModel {
    modifiedBy: string;
    branchModified?: string;
    field: string;
    oldValue: string | null;
    newValue: string | null;
    timestamp: string;

    constructor(dto: BranchManagementChangeLogUserDto) {
        this.modifiedBy = typeof dto.modifiedBy === 'string'
            ? dto.modifiedBy
            : null;
        this.branchModified = dto.branchModified;
        this.field = dto.field;
        this.oldValue = dto.oldValue;
        this.newValue = dto.newValue;
        this.timestamp = dto.timestamp ? formateUTCtoTZ(dto.timestamp) : '';
    }
}
